import { useMemo, useState } from 'react';
import Reveal from '../components/Reveal';
import { useLanguage } from '../context/LanguageContext';

function WhoWeArePage() {
  const { t } = useLanguage();
  const messages = t.whoWeAre.partnerMessages;
  const partnerImages = {
    clubs:
      "url('https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR5gaAGz3qteeIxMGsuChnyoVPGf2dQWDitBA&s')",
    individuals:
      "url('https://images.pexels.com/photos/3183150/pexels-photo-3183150.jpeg?auto=compress&cs=tinysrgb&w=1800')",
    companies:
      "url('https://thumbs.dreamstime.com/b/modern-building-property-real-estate-investment-modern-building-property-real-estate-investment-d-rendering-168991506.jpg')",
    banks:
      "url('https://images.pexels.com/photos/4386398/pexels-photo-4386398.jpeg?auto=compress&cs=tinysrgb&w=1800')",
    governments:
      "url('https://images.pexels.com/photos/466685/pexels-photo-466685.jpeg?auto=compress&cs=tinysrgb&w=1800')",
  };
  const firstId = useMemo(() => messages[0]?.id || '', [messages]);
  const [activePartnerId, setActivePartnerId] = useState(firstId);
  const activePartner = messages.find((item) => item.id === activePartnerId) || messages[0];

  return (
    <main className="inner-page">
      <section className="container who-hero">
        <Reveal>
          <h1>{t.whoWeAre.pageSubtitle}</h1>
          <div
            className="who-hero-image"
            role="img"
            aria-label="Global real estate skyline and city development"
          />
        </Reveal>
      </section>

      <section className="container who-vm-grid">
        <Reveal direction="left">
          <article className="who-card who-vision">
            <div
              className="who-card-image"
              style={{
                backgroundImage: `url('${process.env.PUBLIC_URL}/images/vision.jfif')`,
              }}
              role="img"
              aria-label={t.whoWeAre.visionTitle}
            />
            <h2>{t.whoWeAre.visionTitle}</h2>
            <p>{t.whoWeAre.visionText}</p>
          </article>
        </Reveal>
        <Reveal direction="right">
          <article className="who-card who-mission">
            <div
              className="who-card-image"
              style={{
                backgroundImage: `url('${process.env.PUBLIC_URL}/images/message.jfif')`,
              }}
              role="img"
              aria-label={t.whoWeAre.missionTitle}
            />
            <h2>{t.whoWeAre.missionTitle}</h2>
            <p>{t.whoWeAre.missionText}</p>
          </article>
        </Reveal>
      </section>

      <section className="container who-goals">
        <Reveal>
          <h2 className="center-title">{t.whoWeAre.goalsTitle}</h2>
        </Reveal>
        <div className="cards four">
          {t.whoWeAre.goals.map((goal, index) => (
            <Reveal key={goal} delay={index * 90}>
              <article className="card who-goal-card">
                <span className="who-card-number">{String(index + 1).padStart(2, '0')}</span>
                <p>{goal}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="section who-partners">
        <div className="container">
          <Reveal>
            <div className="services-head">
              <span className="eyebrow center">{t.whoWeAre.partnersTitle}</span>
            </div>
          </Reveal>
          <div className="who-partner-tabs">
            {messages.map((partner) => (
              <button
                type="button"
                key={partner.id}
                className={`who-tab ${activePartnerId === partner.id ? 'who-tab-active' : ''}`}
                onClick={() => setActivePartnerId(partner.id)}
              >
                {partner.label}
              </button>
            ))}
          </div>
          <Reveal key={activePartner.id}>
            <div className="who-partner-layout">
              <div
                className="who-partners-image"
                style={{ backgroundImage: partnerImages[activePartner.id] || partnerImages.clubs }}
                role="img"
                aria-label={activePartner.label}
              />
              <article className="who-partner-panel">
                <h3>{activePartner.label}</h3>
                <p>{activePartner.message}</p>
              </article>
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
}

export default WhoWeArePage;

